export class AnswerValueDto {
    readonly optionId: number;

    constructor(optionId: number) {
        this.optionId = optionId;
    }
}
